import { useEffect } from "react";
import { MacDataServices } from "../services/macDataServices";


export const useUpdateMacOptions = (fetchAndSetOptions,dependency, key, setAppOptionsAvailable, appOptionsAvailable,) => {
  const { fetchPortfolioData, fetchPlatformData, fetchProductData, fetchApplicationData } = MacDataServices();

  useEffect(() => {
    switch(key) {
      case 'app':
        if(dependency)
        // setAppOptionsAvailable(false)
        fetchAndSetOptions(fetchApplicationData, key, dependency, setAppOptionsAvailable, appOptionsAvailable, );
        break;
      case 'product':
        if(dependency)
        // setAppOptionsAvailable(false)
        fetchAndSetOptions(fetchProductData, key, dependency, setAppOptionsAvailable, appOptionsAvailable, );
        break;
      case 'platform':
        if(dependency)
        // setAppOptionsAvailable(false)
        fetchAndSetOptions(fetchPlatformData, key, dependency, setAppOptionsAvailable, appOptionsAvailable, );
        break;
      default:
        // setAppOptionsAvailable(false)
        fetchAndSetOptions(fetchPortfolioData, key,dependency, setAppOptionsAvailable, appOptionsAvailable, );
    }
  }, [dependency]);
}

